module.exports = __webpack_public_path__ + "img/s_agata.1a6379bd.jpg";